import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { copyTextToClipboard } from './qrHelpers';

const QrCopyField = ({ label, value, active = false }) => {
  const [copied, setCopied] = useState(false);
  const hasValue = Boolean(value && String(value).trim());

  const handleCopy = async () => {
    if (!hasValue) return;
    try {
      const ok = await copyTextToClipboard(value);
      if (!ok) return;
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className={`qr-field${active ? ' is-active' : ''}`}>
      <span className="qr-field__label">{label}</span>
      <div className="qr-field__row">
        <div className="qr-field__input" role="textbox" aria-readonly="true">
          {hasValue ? value : '—'}
        </div>
        <button
          type="button"
          className={`qr-copy-btn${copied ? ' is-copied' : ''}`}
          onClick={handleCopy}
          disabled={!hasValue}
          aria-label={`Copy ${label}`}
          title={copied ? 'Copied' : `Copy ${label}`}
        >
          {copied ? <Check className="w-4 h-4" strokeWidth={2.25} /> : <Copy className="w-4 h-4" strokeWidth={2} />}
        </button>
      </div>
      {copied ? <p className="qr-field__hint">Copied to clipboard!</p> : null}
    </div>
  );
};

export default QrCopyField;
